import router from '@/router'
import pick from 'lodash/pick'

import * as types from '@/constants/store-types'

import { ACCOUNT_COOKIE, DEFAULT_OPTIONS } from '@/constants/cookie'

export default {
  [types.SET_ACCOUNT]({ commit }, api = null) {
    const account = this._vm.$cookies.get(ACCOUNT_COOKIE)
    if (account) {
      commit(types.SET_ACCOUNT, account)
      if (api) return api.driverAccount.loginStatus()
    }
  },
  [types.LOGIN]({ commit, getters }, account) {
    delete account.permissions
    this._vm.$cookies.set(ACCOUNT_COOKIE, account, DEFAULT_OPTIONS)
    if (getters.webView) {
      // eslint-disable-next-line no-undef
      app.login(
        account.accessToken,
        getters.clientType,
        String(getters.fingerprint),
        getters.appVersion
      )
    }
    commit(types.SET_ACCOUNT, account)
  },
  [types.REFRESH_TOKEN]({ commit, getters }, { refreshToken, accessToken }) {
    commit(types.REFRESH_TOKEN, { accessToken, refreshToken })

    if (getters.webView) {
      // eslint-disable-next-line no-undef
      app.refreshToken(accessToken)
    }

    this._vm.$cookies.set(ACCOUNT_COOKIE, getters.account, DEFAULT_OPTIONS)
  },
  [types.LOGOUT]({ commit, getters }, redirect = '/login') {
    commit(types.SET_ACCOUNT, null)
    this._vm.$cookies.remove(ACCOUNT_COOKIE, DEFAULT_OPTIONS.path)

    if (getters.webView) {
      // eslint-disable-next-line no-undef
      app.endService()
    }

    if (redirect) router.replace(redirect)
  },
  [types.UPDATE_ACCOUNT]({ state, commit }, api) {
    return api.driverAccount.profile(true).then((updatedProfile) => {
      const account = state.account
      const updatedInformation = pick(updatedProfile, Object.keys(account))
      const updatedAccount = { ...account, ...updatedInformation }

      this._vm.$cookies.set(ACCOUNT_COOKIE, updatedAccount, DEFAULT_OPTIONS)
      commit(types.SET_ACCOUNT, updatedAccount)
    })
  }
}
